import { Center, Loader } from '@mantine/core'
import { useIntersection } from '@mantine/hooks'
import { ReactNode, useEffect } from 'react'

type InfiniteScrollProps = {
  hasMore: boolean
  isFetching: boolean
  children: ReactNode
  loaderSize?: number
  onLoadMore: () => Promise<unknown> | void
  // Required when inside a clipping container like ScrollArea so the observer
  // uses the scroll container as root instead of the browser viewport.
  root?: Element | null
}

export const InfiniteScroll = ({
  hasMore,
  isFetching,
  children,
  loaderSize = 32,
  onLoadMore,
  root
}: InfiniteScrollProps) => {
  const { ref, entry } = useIntersection({
    root: root ?? null,
    threshold: 0.5
  })

  useEffect(() => {
    if (hasMore && entry?.isIntersecting && !isFetching) {
      void onLoadMore()
    }
  }, [hasMore, isFetching, entry, onLoadMore])

  return (
    <div>
      {children}

      <Center ref={ref} mih={isFetching ? 120 : undefined}>
        {isFetching && <Loader size={loaderSize} />}
      </Center>
    </div>
  )
}
